export default __webpack_public_path__ + "static/media/013-gold-ingots.01b4ed8c.png";